import React, { useState } from "react"

import { Link } from "gatsby"
import { GoLocation } from "react-icons/go"
import { AiOutlineLink } from "react-icons/ai"
import Layout from "../layouts/LayoutDefault"
import SEO from "../components/seo"
import "../index.css"
import { Modal } from "../components/elements/Modal"
import Image from "../components/elements/Image"

const CommunityPage = () => {
  const [videoModalActive, setVideomodalactive] = useState(false)

  const openModal = e => {
    e.preventDefault()
    setVideomodalactive(true)
  }

  const closeModal = e => {
    e.preventDefault()
    setVideomodalactive(false)
  }

  return (
    <Layout>
    <SEO title="Community - Makerlapse" />

      <section className="hero section center-content illustration-section-01">
        <div className="container">
          <div class="profile-section">
            <div class="profile-section-image">
              <img src="https://ph-avatars.imgix.net/1670974/original?auto=format&auto=compress&codec=mozjpeg&cs=strip&w=120&h=120&fit=crop"></img>
            </div>
            <div class="profile-section-details">
              <h4 className="mt-0 mb-8">Ilias Haddad</h4>
              <p className="profile-details-location">
                <GoLocation /> Kenitra, Morocco
                <span></span>
                <a href="https://twitter.com/iliashaddad3">
                  {" "}
                  <AiOutlineLink /> Twitter
                </a>
              </p>
              <p className="m-0 text-sm">
                I'm a self taugh developer and I'm trying to build products
                using my coding skills and share them with the world
              </p>
            </div>
          </div>
       

          <div className="gallery-items">
            <div className="gallery-item ">
            <iframe
                    title="video"
                    src={"https://www.youtube.com/embed/digvvOKY3JU"}
                    frameBorder="0"
                    allowFullScreen
                    height="350"
                    width="350"
                  ></iframe> 
          </div>
          <div className="gallery-item ">
            <iframe
                    title="video"
                    src={"https://www.youtube.com/embed/3An5knEUxQU"}
                    frameBorder="0"
                    allowFullScreen
                    height="350"
                    width="350"
                  ></iframe> 
          </div>
          <div className="gallery-item ">
            <iframe
                    title="video"
                    src={"https://www.youtube.com/embed/VoFIJV28Ez0"}
                    frameBorder="0"
                    allowFullScreen
                    height="350"
                    width="350"
                  ></iframe> 
          </div>
        </div>
        </div>
      </section>
    </Layout>
  )
}

export default CommunityPage
